// extracted by mini-css-extract-plugin
module.exports = {"trigger":"ColumnSelector_trigger__1yBQc","panel":"ColumnSelector_panel__3p8jT","row":"ColumnSelector_row__2GT11","label":"ColumnSelector_label__27ayN"};